import { createAsyncThunk } from "@reduxjs/toolkit";
import { waitForTransactionReceipt, writeContract } from "@wagmi/core";
import { TransactionReceipt, Address } from "viem";

import { walletConfig } from "services/wallet";
import { EStakeUnstakeStage } from "shared/interfaces/modal";
import type { ThunkApiConfig } from "store";
import { getStakingData } from "store/actions/view/staking/getStakingData";
import { stakingConfig } from "store/config";
import { setStakingStage } from "store/slices/staking";

export const unstake = createAsyncThunk<
  TransactionReceipt | null,
  {
    address: Address;
    amount: bigint;
    reset(): void;
  },
  ThunkApiConfig
>("staking/unstake", async ({ address, amount, reset }, { dispatch }) => {
  try {
    dispatch(setStakingStage(EStakeUnstakeStage.STAKING_UNSTAKING_PROCESSING));

    const unstakeHash = await writeContract(walletConfig, {
      ...stakingConfig,
      functionName: "unstake",
      account: address,
      args: [amount],
    });

    const receipt = await waitForTransactionReceipt(walletConfig, { hash: unstakeHash });

    if (receipt.status === "success") {
      dispatch(setStakingStage(EStakeUnstakeStage.SUCCESS));
      reset();
    }

    return receipt;
  } catch (e) {
    dispatch(setStakingStage(EStakeUnstakeStage.FAIL));
    console.error(`Error during unstaking:  \n ${e}`);
    return null;
  } finally {
    dispatch(getStakingData({ address }));
  }
});
